import { LayoutFontStyle } from '../../types/types';

const KNOWN_STYLES: LayoutFontStyle[] = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
];

// The object form carries fontStyle as an array, the canvas-level default
// arrives as a string ("bold", possibly space-separated) — unify to the array
// (unknown tokens dropped). undefined/empty → undefined (no styling).
export const normalizeLayoutFontStyle = (
  fontStyle: LayoutFontStyle[] | string | undefined
): LayoutFontStyle[] | undefined => {
  if (fontStyle === undefined || fontStyle === null) {
    return undefined;
  }

  if (Array.isArray(fontStyle)) {
    return fontStyle;
  }

  const styles = fontStyle
    .split(/\s+/)
    .filter((token): token is LayoutFontStyle =>
      KNOWN_STYLES.includes(token as LayoutFontStyle)
    );

  return styles.length > 0 ? styles : undefined;
};
